import React from 'react';
import KpiGridCard from './KpiGridCard';
import DataTableCard from './DataTableCard';
import ComparisonCard from './ComparisonCard';
import FunnelCard from './FunnelCard';
import TrendSummaryCard from './TrendSummaryCard';
import TrendChartCard from './TrendChartCard';
import RecommendationsCard from './RecommendationsCard';
import AnomalyAlertCard from './AnomalyAlertCard';

const StructuredCardRenderer = ({ card }) => {
  if (!card || !card.type) return null;

  switch (card.type) {
    case 'kpi_grid':
      return <KpiGridCard card={card} />;
    case 'data_table':
      return <DataTableCard card={card} />;
    case 'comparison':
      return <ComparisonCard card={card} />;
    case 'funnel':
      return <FunnelCard card={card} />;
    case 'trend_summary':
      return <TrendSummaryCard card={card} />;
    case 'trend_chart':
      return <TrendChartCard card={card} />;
    case 'recommendations':
      return <RecommendationsCard card={card} />;
    case 'anomaly_alert':
      return <AnomalyAlertCard card={card} />;
    default:
      return null;
  }
};

export default StructuredCardRenderer;
